import { render, staticRenderFns } from "./UpdatePWA.vue?vue&type=template&id=1479f184&scoped=true"
import script from "./UpdatePWA.vue?vue&type=script&lang=js"
export * from "./UpdatePWA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479f184",
  null
  
)

export default component.exports